import { Box, Card } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import './SmartMetering.scss';
import backgroundImage from '../../../images/FaintBackground.jpg';
import HamburgerIcon from '../../../components/HamburgerIcon/HamburgerIcon';
import { ButtonFilled } from '../../../components/Button/Button';

function SmartMetering() {
  const handleContactUs = () => {
    window.location.replace('https://evalue8.net/contact/');
  };

  return (
    <Card
      sx={{
        margin: '20px',
        borderRadius: '20px',
        padding: '40px',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        opacity: 1,
        filter: 'brightness(1.05)',
        minHeight: 'calc(100% - 50px)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div className="smart-metering">
        <HamburgerIcon />
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: { xs: 6, md: 10 },
          }}
        >
          <Box
            sx={{
              width: '100%',
              maxWidth: '760px',
              textAlign: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              borderRadius: '24px',
              px: { xs: 3, md: 8 },
              py: { xs: 5, md: 7 },
              boxShadow: '0 18px 45px rgba(35, 57, 63, 0.12)',
            }}
          >
            <Box
              sx={{
                width: '84px',
                height: '84px',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(97, 185, 195, 0.14)',
                color: '#2e6e76',
                margin: '0 auto 24px',
              }}
            >
              <LockOpenIcon sx={{ fontSize: '42px' }} />
            </Box>

            <div
              style={{
                fontSize: '34px',
                fontWeight: 600,
                color: '#24454b',
                marginBottom: '16px',
              }}
            >
              Product Carbon Footprints
            </div>

            <div
              style={{
                fontSize: '18px',
                lineHeight: 1.7,
                color: '#4c666b',
                maxWidth: '560px',
                margin: '0 auto 32px',
              }}
            >
              This module is currently locked. Contact us for pricing and
              activation to enable Product Carbon Footprints for your
              organisation.
            </div>

            <ButtonFilled handleSubmit={handleContactUs}>
              Contact Us
            </ButtonFilled>
          </Box>
        </Box>
      </div>
    </Card>
  );
}

export default SmartMetering;
